import { HTMLProps, useState } from 'react'
import clsx from 'classnames'
import { useTranslations } from 'next-intl'
import { useLocale } from 'use-intl'
import { FiltersBar } from '@/shared/ui/filters-bar'
import { getCategoryId, useScaleSection } from '@/shared/utils'
import { AnalyticsList } from '@/features/analytics-list'
import { Button } from '@/shared/ui'
import type { IPostPreview } from '@/interfaces/analytics'
import { IPostCategory } from '@/interfaces/analytics'
import getPosts, { GetPostsParams } from '@/actions/getPosts'
import { localeMap } from '@/shared/utils/directus'
import style from './main-analytics.module.scss'

type FeedProps = HTMLProps<HTMLDivElement> & { posts: Omit<IPostPreview[], 'blocks'>; postCategories: IPostCategory[] }

const AllAnalyticsBtn = ({ className }: HTMLProps<HTMLButtonElement | HTMLDivElement>) => {
  const translate = useTranslations('')

  return (
    <Button className={className} href="/analytics">
      {translate('buttonAllAnalytics')}
    </Button>
  )
}

export const MainAnalytics = (props: FeedProps) => {
  const { className, children, postCategories, posts } = props
  const sectionRef = useScaleSection(true, 0.7)
  const currentLocale = useLocale()
  const [cards, setCards] = useState<IPostPreview[]>(posts)

  const fetchData = ({ categoryId }: GetPostsParams) => {
    getPosts({ locale: localeMap[currentLocale], categoryId })
      .then(({ items, total, limit }) => {
        setCards(items)
      })
      .catch(error => {
        console.error(error)
      })
  }
  const onChangeCategory = (filter: IPostCategory | null) => {
    const categoryId = getCategoryId(filter)

    fetchData({ categoryId })
  }

  return (
    <section
      id="feed"
      className={clsx(style.container, 'main-padding', 'white-section white-section-js', className)}
      ref={sectionRef}
    >
      <FiltersBar filters={postCategories} onFilterChange={onChangeCategory} renderButton={AllAnalyticsBtn} />
      <AnalyticsList cards={cards.slice(0, 3)} />
      <AllAnalyticsBtn className={style.mobileLink} />
      {children}
    </section>
  )
}
